// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nY78","content":"styles_content__28Azb"};